import { exhaustiveCheckWarn } from './exhaustive-check';

import { BusinessUnit } from '~shared/business-unit';

export interface LoyaltyProgram {
  name: 'rewardClub' | 'extra' | 'innerCircle';
  request: 'REWARD_CLUB' | 'EXTRA' | 'INNER_CIRCLE';
}

export const getLoyaltyProgramData = (bu: BusinessUnit): LoyaltyProgram => {
  switch (bu) {
    case BusinessUnit.PL:
    case BusinessUnit.NO:
    case BusinessUnit.SE:
    case BusinessUnit.DK:
    case BusinessUnit.LV:
    case BusinessUnit.LT:
    case BusinessUnit.EE:
      return { name: 'extra', request: 'EXTRA' };

    case BusinessUnit.NL:
    case BusinessUnit.LU:
    case BusinessUnit.BE:
    case BusinessUnit.DE:
      return { name: 'rewardClub', request: 'REWARD_CLUB' };

    case BusinessUnit.US:
    case BusinessUnit.CA:
    case BusinessUnit.Mock:
      return { name: 'innerCircle', request: 'INNER_CIRCLE' };

    default:
      exhaustiveCheckWarn(bu);

      return { name: 'innerCircle', request: 'INNER_CIRCLE' };
  }
};
